import React from 'react';
import styled from 'styled-components';
import { colors } from '../../../../../constants/colors';
import { isNativeApp, isNativeTelemedSupported } from '../../../../../core/util/device';
import { isTelemedLocation } from '../../../../../core/util/location';
import { fontFamily, fontSize } from '../../../../../constants/text';
import Button, { ButtonVariations } from '../../../../SolvPatternLibrary/Button';
import { getNativeStoreDownloadLink } from '../../../../DownloadDriver/util';
import { NativeFunctions } from '../../../../../core/util/native';

const Root = styled.div.withConfig({ componentId: 'sc-6vut5v-0' })`
  border-top: 1px solid ${colors.fatherJohnMisty};
  padding: 16px 24px;
`;

const Copy = styled.div.withConfig({ componentId: 'sc-6vut5v-1' })`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fontFamily.medium};
  color: ${colors.squid};
  font-size: ${fontSize.small};
`;

const UpdateAppButton = styled(Button).withConfig({ componentId: 'sc-6vut5v-2' })`
  width: 5px;
  margin-left: 5px;
  padding: 15px 40px;
  text-align: center;
`;

type Props = {
  location?: any;
};

const UpdateApp = (props: Props) => {
  const { location } = props;
  const openLink = NativeFunctions.openNativeUrl;

  const nativeApp = isNativeApp();
  if (!isTelemedLocation(location) || !nativeApp || (nativeApp && isNativeTelemedSupported()))
    return null;

  const handleUpdateAppButtonClick = () => {
    if (openLink.exists) {
      const campaignName = 'update-solv-app-from-telemed-cta-account';
      let urlNativeDownloadLink = getNativeStoreDownloadLink(campaignName);
      openLink.call(urlNativeDownloadLink);
    }
  };

  const shouldShowUpdateAppButton = () => {
    return openLink.exists;
  };

  return (
    <Root>
      <Copy>
        This version of the app doesn't support video visits. Please update to the latest version.
        {shouldShowUpdateAppButton() && (
          <UpdateAppButton
            onClick={handleUpdateAppButtonClick}
            variation={ButtonVariations.tertiary}
          >
            Update
          </UpdateAppButton>
        )}
      </Copy>
    </Root>
  );
};

export default UpdateApp;
